import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrDashboardPage } from './klmr-dashboard';

@NgModule({
  declarations: [
    KlmrDashboardPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrDashboardPage),
  ],
})
export class KlmrDashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-dashboard/klmr-dashboard.module.ts